import { useState, useCallback } from 'react';

/**
 * Generic hook for managing table row expand/collapse state
 * Used for grouping/bundling functionality in tables
 */
export function useTableExpand() {
  const [expandedGroups, setExpandedGroups] = useState<Set<number>>(new Set());

  const toggleExpand = useCallback((itemId: number) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  }, []);

  const isExpanded = useCallback((itemId: number | null) => {
    return itemId !== null && expandedGroups.has(itemId);
  }, [expandedGroups]);

  const collapseAll = useCallback(() => {
    setExpandedGroups(new Set());
  }, []);

  const expandAll = useCallback((itemIds: number[]) => {
    setExpandedGroups(new Set(itemIds));
  }, []);

  return {
    expandedGroups,
    toggleExpand,
    isExpanded,
    collapseAll,
    expandAll,
  };
}

